<template>
  <div class="button" :style="setBgColor" :class="classsObj" @click="buttonClick">
    {{text}}
  </div>
</template>

<script>

export default {
  name: '',
  props: {
    text: {
      type: String,
    },
    buttonType: {
      type: String,
    },
    fullWidth: {
      type: Boolean,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    globalConfig:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {

    };
  },

  components: {},

  computed: {
    classsObj() {
      return {
        default: this.buttonType === 'default' && !this.disable,
        login: this.buttonType === 'login' && !this.disable,
        back: this.buttonType === 'back' && !this.disable,
        fullWidth: this.fullWidth === true,
        disabled: this.disable === true,
      };
    },
    setBgColor(){
      return{
        'backgroundColor':this.globalConfig.vice,
        'color':this.globalConfig.main,

      }
    }
  },

  beforeMount() {},

  mounted() {
    
  },

  methods: {
    buttonClick() {
      if (!this.disable) {
        this.$emit('handleClick');
      }
    },
  },

  watch: {},

};

</script>
<style lang='less' scoped>
  .button {
    width:180px;
    height:40px;
    border-radius:20px;
    line-height: 40px;
    text-align: center;
    font-size:15px;
    font-family:PingFang SC;
    font-weight:500;
    // background:rgba(190,190,190,1);
    // border:2px solid rgba(162, 162, 162, 1);
    &:hover {
      cursor: pointer;
    }
  }
  .login {
    color:rgba(255,255,255,1);
    height:40px;
    // background:rgba(104,149,60,1);
    border-radius:20px;
    // border:2px solid rgba(80,123,54,1);
    box-sizing: border-box;
    font-size: 16px;
    line-height: 40px;
    &:hover {
      // background:rgba(80,123,54,1);
      // border:2px solid rgba(80,123,54,1);
    }
  }
  .default {
    color:rgba(255,255,255,1);
    background:rgba(190,190,190,1);
    border:2px solid rgba(162, 162, 162, 1);
    &:active {
      color:rgba(103,103,103,1);
    }
    &.fullWidth{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      line-height:40px;
      width:345px;
      height:40px;
      border-radius:20px;
    }
  }
  .disabled {
    cursor: not-allowed!important;
    color:rgba(255,255,255,1);
    background:rgba(190,190,190,1);
    // border:2px solid rgba(162, 162, 162, 1);
  }
  .back {
    height:40px;
    background:rgba(255,255,255,1);
    border-radius:20px;
    border:2px solid rgba(80,123,54,1);
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(80,123,54,1);
    &:hover {
      width:165px;
      height:40px;
      background:rgba(104,149,60,1);
      border-radius:20px;
      color:rgba(255,255,255,1);
    }
  }
</style>
